import { useEffect, useState } from 'react';
import { Menu, Moon, Sun } from 'lucide-react';
import w3Logo from '@/assets/w3-logo-official.png';

interface HeaderProps {
  onOpenSidebar: () => void;
}

const THEME_KEY = 'w3suite_theme';

/** Header glassmorphism fisso in stile demo (blur + saturate). */
export function Header({ onOpenSidebar }: HeaderProps) {
  const [dark, setDark] = useState<boolean>(() => localStorage.getItem(THEME_KEY) === 'dark');

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light');
  }, [dark]);

  return (
    <header className="w3-glass-header sticky top-0 z-30 h-16 flex items-center gap-3 px-4">
      <button
        type="button"
        onClick={onOpenSidebar}
        className="lg:hidden p-2 rounded-md text-muted-foreground hover:bg-muted"
        aria-label="Apri menu"
      >
        <Menu className="w-5 h-5" />
      </button>

      <div className="flex items-center gap-2 lg:hidden">
        <img src={w3Logo} alt="W3" className="h-7 w-auto mix-blend-multiply dark:mix-blend-normal" />
        <span className="text-lg font-bold text-w3-orange">Suite</span>
      </div>

      <div className="ml-auto flex items-center gap-3">
        <button
          type="button"
          onClick={() => setDark((d) => !d)}
          className="p-2 rounded-md text-muted-foreground hover:text-w3-orange hover:bg-w3-orange/10 transition-colors"
          aria-label="Cambia tema"
        >
          {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </button>
      </div>
    </header>
  );
}
